export default {
  root: ({ props }) => ({
    class: [
      'inline-block relative',
      'w-12 h-6',
      'rounded-full',
      {
        'opacity-60 select-none pointer-events-none cursor-default':
          props.disabled
      }
    ]
  }),
  slider: ({ props }) => ({
    class: [
      // Position
      'absolute top-0 left-0 right-0 bottom-0',
      {
        'before:transform before:translate-x-6':
          props.modelValue == props.trueValue
      },

      // Shape
      'rounded-full',

      // Before: (the toggle handle)
      'before:absolute before:top-1/2 before:left-1',
      'before:-mt-2.5',
      'before:h-5 before:w-5',
      'before:rounded-full',
      'before:duration-200',
      'before:bg-white',
      'before:shadow-sm',

      // Colors
      'border-0',
      {
        'bg-gray-300 dark:bg-gray-700': !(props.modelValue == props.trueValue),
        'bg-green-600 dark:bg-green-500': props.modelValue == props.trueValue,
        'border-transparent': !props.invalid
      },

      // Invalid State
      { 'border-red-500 dark:border-red-400': props.invalid },

      // States
      {
        'peer-hover:bg-gray-400 dark:peer-hover:bg-gray-600':
          !(props.modelValue == props.trueValue) &&
          !props.disabled &&
          !props.invalid
      },
      {
        'peer-hover:bg-green-700 dark:peer-hover:bg-green-600':
          props.modelValue == props.trueValue &&
          !props.disabled &&
          !props.invalid
      },
      'peer-focus-visible:ring-2 peer-focus-visible:ring-offset-2 peer-focus-visible:ring-green-500 dark:peer-focus-visible:ring-green-400',

      // Transition
      'transition-colors duration-200',

      // Misc
      'cursor-pointer'
    ]
  }),
  input: {
    class: [
      'peer',
      // Size
      'w-full',
      'h-full',

      // Position
      'absolute',
      'top-0 left-0',
      'z-10',

      // Spacing
      'p-0',
      'm-0',

      // Shape
      'opacity-0',
      'rounded-full',
      'outline-none',

      // Misc
      'appearance-none',
      'cursor-pointer'
    ]
  }
}
